import * as React from "react";
import * as React44ms from "../../../Util/form-utils/react-44ms";

import { SingleLineTextInput2023ViewModel } from "../ui2023";

import {
  FormLogicEventBehaviour,
  FormLogicEventBehaviour_OnChange,
  GenericTextFieldFormLogic,
  GenericTextFieldFormLogicProps,
} from "./generic";

export interface AnyNameFormLogicProps {
  formRef: React44ms.Api.TypedRef<SingleLineTextInput2023ViewModel>;
  required: GenericTextFieldFormLogicProps["required"];
}
export const AnyNameFormLogic: React.FunctionComponent<
  AnyNameFormLogicProps
> = (props) => (
  <GenericTextFieldFormLogic
    ref={props.formRef}
    required={props.required}
    maxLength={maxNameLength}
    behaviour={{
      onFocus: FormLogicEventBehaviour.nothing,
      onChange: FormLogicEventBehaviour_OnChange.mutateWithValidation,
      onBlur: FormLogicEventBehaviour.validate,
      onSubmit: FormLogicEventBehaviour.validate,
    }}
  />
);

export const maxNameLength = 50;
